import { useFormik } from "formik";
import { toast } from "react-toastify";

// Components
import { Body, Header } from "../../../../../components/UI";
import { Heading2 } from "../../../../../components/typography";

// Containers
import StaffForm from "../StaffForm/StaffForm";

// Icons
import { Close } from "../../../../../SVGS";

// Form Model
import { StaffMemberFormModel } from "../../../../../models/app/forms";

// Calls
import { createStaffMemberRequest } from "../../../../../api/calls/general-branch-settings.call";

// Services
import { staffValidate } from "../../../../../services/validations/staffValidation";

// Styles
import { AddStaffStyles } from "./addStaff.styles";

const AddStaff = ({
  roles,
  closeModal,
  branchId,
  setStaffMembersAfterCreateOrEdit
}) => {
  const createStaffHandler = async values => {
    const response = await createStaffMemberRequest(branchId, values);
    if (response.hasError) {
      toast.error(response.error.message);
      return;
    }
    toast.success("Staff member successfully created.");
    setStaffMembersAfterCreateOrEdit(response.staffMembers);
  };

  const formik = useFormik({
    initialValues: new StaffMemberFormModel(),
    onSubmit: createStaffHandler,
    validate: staffValidate
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldTouched,
    setFieldValue,
    handleChange,
    handleBlur
  } = formik;

  return (
    <AddStaffStyles>
      <Header className="formHeader">
        <Heading2>ADD STAFF</Heading2>
        <Close onClick={closeModal} />
      </Header>
      <Body>
        <form autoComplete="new-password" onSubmit={handleSubmit}>
          <StaffForm
            roles={roles}
            values={values}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
            handleBlur={handleBlur}
            setFieldTouched={setFieldTouched}
            setFieldValue={setFieldValue}
            buttonText="Add Staff"
          />
        </form>
      </Body>
    </AddStaffStyles>
  );
};

export default AddStaff;
